import { createStore } from 'react-hooks-global-state'
import { persistStore } from 'redux-persist'
import reducer from './reducers'

const store = createStore(reducer, undefined)

export const { GlobalStateProvider, dispatch, useGlobalState, getState } = store

export const persistor = persistStore(store, null, () => {
  // if you want to get restoredState
  //console.log('restoredState', store.getState())
})
